module.exports = __webpack_public_path__ + "static/media/dark_red_18.07f6a55d.svg";